module.exports = __webpack_public_path__ + "static/media/atp-backup.3b9ac1dd.png";